import { render, staticRenderFns } from "./createServiceProvider.vue?vue&type=template&id=57e97c69&scoped=true&"
import script from "./createServiceProvider.vue?vue&type=script&lang=js&"
export * from "./createServiceProvider.vue?vue&type=script&lang=js&"
import style0 from "./createServiceProvider.vue?vue&type=style&index=0&id=57e97c69&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e97c69",
  null
  
)

export default component.exports